import { connect } from 'react-redux';
import isNil from 'lodash/isNil';
import has from 'lodash/has';
import {
  getAllReusableTransforms,
  loadDataFeedDataSets,
  loadDataSet,
  loadMyAvailableDataSet,
  loadMyAvailableDataSets,
  setContextualSupport,
  setListingACLQueryMode,
  unsetContextualSupport,
} from 'js/actions';
import {
  getDataSetsPageRequestStatus,
  getMyAvailableDatasetEntities,
  getMyDataSetEntities,
} from 'js/reducers/selectors';
import UIUtils from 'js/lib/UIUtils';
import { getConnectionOrVendorType, isDetectedDataset } from 'js/lib/ResourceUtils';
import * as OLD_PATHS from 'js/constants/pathnames';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import ViewDataSets from './ViewDataSets';
import { ModalFilePreview } from 'new/elements/ModalFilePreview';
import { ModalReingest } from 'new/elements/ModalReingest';
import { ModalAddToMarketplace } from 'new/elements/ModalAddToMarketplace/ModalAddToMarketplace';

const mapStateToProps = (state, ownProps) => {
  const {
    app: {
      listing: { selectedCardId, aclQueryMode },
      visibilityFilters: { filters, availableFilters },
    },
    entities,
    dataSetSchemas,
  } = state;
  const resourceId = UIUtils.extractParamFromURL(ownProps.match);

  const getSourceMetaFromDataSet = (dataSetId, isDetected) => {
    // check if it is source/sink
    const {
      entities: { dataSets, sources, vendors },
      paging: { metaInfoById },
    } = state;
    const dataSet = dataSets[dataSetId];
    if (isDetected === false) {
      return null;
    }
    if (isNil(isDetected) && isDetectedDataset(dataSet) === false) {
      return null;
    }

    const sourceId = dataSet.data_source;
    const sourceEntity = sources[sourceId];

    const connectionOrVendorType = getConnectionOrVendorType(
      sourceEntity,
      vendors,
      'source_type',
      'vendor_id',
    );

    return connectionOrVendorType && has(metaInfoById, connectionOrVendorType)
      ? metaInfoById[connectionOrVendorType]
      : null;
  };

  return {
    entities,
    dataSetSchemas,
    availableFilters,
    resourceId,
    selectedCardId,
    aclQueryMode,
    dataSets: getMyDataSetEntities(state),
    isLoading: getDataSetsPageRequestStatus(state),
    filters: filters,
    availableDatasets: getMyAvailableDatasetEntities(state),
    getSourceMetaFromDataSet,
  };
};

const ViewDataSetsContainer = connect(mapStateToProps, {
  loadDataFeedDataSets,
  loadDataSet,
  loadMyAvailableDataSets,
  loadMyAvailableDataSet,
  getAllReusableTransforms,
  setContextualSupport,
  setListingACLQueryMode,
  unsetContextualSupport,
})(ViewDataSets);

ViewDataSetsContainer.screenConfig = {
  screenName: 'ViewDataSetsContainer',
  domain: 'integrate',
  header: {
    title: 'Nexsets',
    slugTitle: 'All',
  },
  modals: [ModalFilePreview, ModalReingest, ModalAddToMarketplace],
  pageTitle: 'Nexsets',
  path: [`${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_MY_DATA_SETS}`],
  exact: true,
  defaultProps: {
    onlyTableView: true,
  },
};

export default ViewDataSetsContainer;
